import React from 'react';
import { Container, Row, Col} from 'react-bootstrap';

const Events = () => {
  return (
    <Container className='d-flex justify-content-center sectionalContainer'>
      <Row>
        <Col lg={12} className='w-100'>
          <p className='eventsText text-center'>Events</p>
        </Col>
        <Col lg={12} className='w-100'>
          <a className='eventsImageContainer mt-5' href='https://hollywoodnightcruisers.com'>
            <img className = "eventsImage" src='./images/eventImages/HWNightCruisersFlyer.png' alt=''/>
          </a>
        </Col>    
        <Col lg={12} className='w-100'>
            <p className='eventsText'>
              Starting Appril 13th, 2025<br></br>
              Every Sunday <br></br>
              12:00pm-3:00pm<br></br>
              Come join us as we host Hollywood Night Cruisers antique car show with Joe Primiano
            </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Events;
